<template>
  <v-app class="doctor-entry-form employee-entry-form" style="background-color: transparent !important; min-height: auto !important;">
    <div class="row doctor-entry-form__layout">
      <div class="col-lg-3 col-md-4 mb-6 doctor-entry-form__media-column">
        <div class="card card-custom border-0 shadow-sm rounded-xl overflow-hidden">
          <div class="card-body text-center p-6">
            <h5 class="font-weight-bolder mb-5 text-dark-75">Foto Profil</h5>
        <div class="row">
          <div
            class="col-md-12 col-lg-12 col-sm-12 mb-2"
          >
            <div class="d-flex justify-content-center mb-5">
              <div class="image-input image-input-outline image-input-circle bg-light" style="width: 160px; height: 160px; border-radius: 50%; overflow: hidden; position: relative; border: 4px solid #ffffff; box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0,0,0,.05);">
                <!-- upload Preview -->
                <img
                  class="w-100 h-100"
                  style="object-fit: cover;"
                  :src="[
                    uploadedImageUrl == '' ? form.photo_name : uploadedImageUrl,
                  ]"
                  @load="onImageLoad()"
                  v-if="uploadMethod == 'upload'"
                />

                <!-- camera -->
                <div v-if="uploadMethod == 'camera'" class="mb-3">
                  <vue-web-cam
                    ref="webcam"
                    :device-id="deviceId"
                    width="100%"
                    @started="onStarted"
                    @stopped="onStopped"
                    @error="onError"
                    @cameras="onCameras"
                    @camera-change="onCameraChange"
                    v-if="captureStatus == false"
                  />

                  <figure class="figure" v-else-if="captureStatus == true">
                    <img :src="baseImg" class="img-responsive doctor-entry-form__capture" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
            <div class="d-flex flex-column mt-4">
              <span class="text-muted font-weight-bold font-size-sm mb-3">
                Mode: <span class="text-primary">{{ uploadMethod == "upload" ? "Unggah File" : "Kamera" }}</span>
              </span>
              <div class="d-flex justify-content-center mb-3" style="gap: 8px;">
                <button type="button" class="btn btn-light-success font-weight-bolder btn-sm rounded-lg flex-fill" @click="changeUploadBtn" v-if="uploadMethod == 'upload'">
                  <i class="fas fa-camera mr-1"></i> Kamera
                </button>
                <button type="button" class="btn btn-light-primary font-weight-bolder btn-sm rounded-lg flex-fill" @click="changeUploadBtn" v-if="uploadMethod == 'camera'">
                  <i class="fas fa-upload mr-1"></i> Unggah
                </button>
                <button type="button" class="btn btn-light-danger font-weight-bolder btn-sm rounded-lg flex-fill" @click="resetImg">
                  <i class="fas fa-undo mr-1"></i> Reset
                </button>
              </div>
              <div v-if="uploadMethod == 'camera'" class="mt-2">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bolder rounded-lg w-100"
                  v-if="uploadMethod == 'camera' && captureStatus == false"
                  @click="onCapture"
                >
                  <i class="fas fa-dot-circle mr-1"></i> Ambil Foto
                </button>
              </div>
            </div>
          </div>
        </div>
          </div>
        </div>

      <div class="col-md">
        <b-form
          @submit.stop.prevent="formOnSubmit"
          enctype="multipart/form-data"
        >
          <b-alert v-if="validationMessages.length" show variant="danger" class="mb-5">
            <strong>Data karyawan belum dapat disimpan.</strong>
            <ul class="mb-0 mt-2 pl-5"><li v-for="message in validationMessages" :key="message">{{ message }}</li></ul>
          </b-alert>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Informasi Karyawan</h5></div>
            <div class="card-body p-6 operational-form-grid">
          <b-form-group
            id="input-group-employee-numebr"
            label="Nomor Karyawan:"
            label-for="input-employee-numebr"
          >
            <b-form-input
              id="input-employee-number"
              v-model="form.employee_number_id"
              placeholder="Nomor karyawan"
            >
            </b-form-input>
            <small class="text-danger">{{ error.employee_number_id }}</small>
          </b-form-group>

          <b-form-group
            id="input-group-name"
            label="Nama:"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              placeholder="Nama Lengkap"
            >
            </b-form-input>
            <small class="text-danger">{{ error.name }}</small>
          </b-form-group>

          <b-form-group id="input-group-ktp">
            <label for="input-ktp"
              >Nomor Ktp: <em class="text-muted">opsional</em></label
            >
            <b-form-input
              id="input-ktp"
              v-model="form.id_card_number"
              placeholder="Nomor Ktp"
            >
            </b-form-input>
            <small class="text-danger">{{ error.id_card_number }}</small>
          </b-form-group>

          <b-form-group
            id="input-group-birth-date"
            class="operational-form-grid__wide"
            label="Tempat & Tanggal Lahir:"
            label-for="input-sip-birth-date"
          >
            <b-input-group>
              <div class="row">
                <div class="col-md-6">
                  <b-form-input
                    id="input-birth-place"
                    aria-label="Tempat Lahir"
                    placeholder="Tempat Lahir (opsional)"
                    v-model="form.birt_place"
                  ></b-form-input>
                </div>
                <div class="col-md-6">
                  <v-dialog
                    ref="dialog"
                    v-model="modal2"
                    :return-value.sync="form.date"
                    persistent
                    width="350px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <b-input-group>
                        <b-input-group-prepend>
                          <button
                            class="btn btn-secondary"
                            type="button"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <i class="fas fa-calendar"></i>
                          </button>
                        </b-input-group-prepend>
                        <b-form-input
                          id="input-trigger-modal-patient"
                          v-model="form.birt_date"
                          placeholder="Tanggal Lahir (YYYY-MM-DD)"
                          @input="formaterDate"
                        >
                        </b-form-input>
                      </b-input-group>
                    </template>

                    <v-date-picker
                      v-if="modal2"
                      v-model="form.birt_date"
                      locale="id"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal2 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(form.birt_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </b-input-group>
            <div class="row">
              <div class="col">
                <small class="text-danger">{{ error.birt_place }}</small>
              </div>
              <div class="col">
                <small class="text-danger">{{ error.birt_date }}</small>
              </div>
            </div>
          </b-form-group>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Informasi Akun</h5></div>
            <div class="card-body p-6 operational-form-grid">
          <b-form-group id="input-group-email">
            <label for="input-email">Email:</label>
            <b-form-input id="input-email" v-model="form.email" type="email" placeholder="Email"></b-form-input>
            <small class="text-danger">{{ error.email }}</small>
          </b-form-group>

          <template v-if="password">
            <!-- Input Password -->
            <div class="form-group">
              <label for="password">Password:</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    @click="
                      passwordIsVisible == 'password'
                        ? (passwordIsVisible = 'text')
                        : (passwordIsVisible = 'password')
                    "
                  >
                    <div v-if="passwordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </div>
                    <div v-if="passwordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </div>
                  </div>
                </div>
                <input
                  :type="passwordIsVisible"
                  class="form-control"
                  placeholder="Password"
                  v-model="form.password"
                  id="input-password"
                />
              </div>
              <small class="text-danger">{{ error.password }}</small>
            </div>

            <!-- Input Password Confirmation -->
            <div class="form-group">
              <label for="password">Ulangi Password:</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <div
                    class="input-group-text"
                    @click="
                      confirmPasswordIsVisible == 'password'
                        ? (confirmPasswordIsVisible = 'text')
                        : (confirmPasswordIsVisible = 'password')
                    "
                  >
                    <div v-if="confirmPasswordIsVisible == 'password'">
                      <b-icon-eye-slash></b-icon-eye-slash>
                    </div>
                    <div v-if="confirmPasswordIsVisible == 'text'">
                      <b-icon-eye></b-icon-eye>
                    </div>
                  </div>
                </div>
                <input
                  :type="confirmPasswordIsVisible"
                  class="form-control"
                  placeholder="Ulangi Password"
                  v-model="form.password_confirmation"
                  id="input-password-confirmation"
                />
              </div>
              <small class="text-danger">{{
                error.password_confirmation
              }}</small>
            </div>
          </template>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Penempatan & Jam Kerja</h5></div>
            <div class="card-body p-6 operational-form-grid">
          <b-form-group
            id="input-group-position"
            label="Jabatan :"
            label-for="input-position"
          >
            <b-form-select
              id="input-position"
              v-model="form.position_id"
              :options="positions"
            ></b-form-select>
            <small class="text-danger">{{ error.position_id }}</small>
          </b-form-group>

          <b-form-group
            id="input-group-department"
            label="Departemen :"
            label-for="input-department"
          >
            <b-form-select
              id="input-department"
              v-model="form.department_id"
              :options="departments"
            ></b-form-select>
            <small class="text-danger">{{ error.department_id }}</small>
          </b-form-group>

              <b-form-group label="Jam Masuk Kerja:" label-for="work-start-time">
                <b-form-input id="work-start-time" v-model="form.work_start_time" type="time"></b-form-input>
                <small class="text-danger">{{ error.work_start_time }}</small>
              </b-form-group>
              <b-form-group label="Jam Pulang Kerja:" label-for="work-end-time">
                <b-form-input id="work-end-time" v-model="form.work_end_time" type="time"></b-form-input>
                <small class="text-danger">{{ error.work_end_time }}</small>
              </b-form-group>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Ketenagakerjaan & Payroll</h5></div>
            <div class="card-body p-6 operational-form-grid">
            <b-form-group label="Status Karyawan"><b-form-select v-model="form.employment_status" :options="employmentOptions" /></b-form-group>
            <b-form-group label="Tanggal Bergabung"><b-form-input v-model="form.join_date" type="date" /></b-form-group>
            <b-form-group label="Kontrak Berakhir"><b-form-input v-model="form.end_date" type="date" /></b-form-group>
            <b-form-group label="Gaji Pokok"><b-input-group prepend="Rp"><b-form-input v-model="form.base_salary" type="number" min="0" /></b-input-group></b-form-group>
            <b-form-group label="Status PTKP"><b-form-select v-model="form.ptkp_status" :options="ptkpOptions" /></b-form-group>
            <b-form-group label="NPWP"><b-form-input v-model="form.npwp" placeholder="Nomor NPWP" /></b-form-group>
            <b-form-group label="Bank"><b-form-input v-model="form.bank_name" placeholder="Nama bank" /></b-form-group>
            <b-form-group label="Nomor Rekening"><b-form-input v-model="form.bank_account_number" placeholder="Nomor rekening" /></b-form-group>
            <b-form-group label="Nama Pemilik Rekening"><b-form-input v-model="form.bank_account_name" placeholder="Sesuai rekening" /></b-form-group>
            <b-form-group label="Nomor BPJS Kesehatan"><b-form-input v-model="form.bpjs_health_number" /></b-form-group>
            <b-form-group label="Nomor BPJS Ketenagakerjaan"><b-form-input v-model="form.bpjs_employment_number" /></b-form-group>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Kredensial Tenaga Kesehatan</h5></div>
            <div class="card-body p-6 operational-form-grid">
            <b-form-group label="Nomor STR"><b-form-input v-model="form.str_number" /></b-form-group>
            <b-form-group label="Masa Berlaku STR"><b-form-input v-model="form.str_expired_at" type="date" /></b-form-group>
            <b-form-group label="Nomor SIP"><b-form-input v-model="form.sip_number" /></b-form-group>
            <b-form-group label="Masa Berlaku SIP"><b-form-input v-model="form.sip_expired_at" type="date" /></b-form-group>
            </div>
          </div>

          <div class="card card-custom border-0 shadow-sm rounded-xl mb-6">
            <div class="card-header bg-transparent border-0 pt-6 pb-0"><h5 class="card-title font-weight-bolder text-dark-75 mb-0">Kontak</h5></div>
            <div class="card-body p-6 operational-form-grid">
          <b-form-group id="input-group-mobile-phone" label="Nomor Handphone:" label-for="input-mobile-phone">
            <b-form-input id="input-mobile-phone" v-model="form.mobile_phone" placeholder="Nomor Handphone" inputmode="numeric"></b-form-input>
            <small class="text-danger">{{ error.mobile_phone }}</small>
          </b-form-group>
          <b-form-group id="input-group-phone">
            <label for="input-phone">Telepon: <em class="text-muted">opsional</em></label>
            <b-form-input id="input-phone" v-model="form.phone" placeholder="Telepon"></b-form-input>
            <small class="text-danger">{{ error.phone }}</small>
          </b-form-group>
          <RegionAddressFields :form="form" />
          <b-form-group id="input-group-address" class="operational-form-grid__wide">
            <label for="input-address"
              >Alamat: <em class="text-muted">opsional</em></label
            >
            <b-form-textarea
              id="input-address"
              v-model="form.address"
              placeholder="Alamat Lengkap"
              rows="4"
              max-rows="6"
            ></b-form-textarea>
            <small class="text-danger">{{ error.address }}</small>
          </b-form-group>

          <b-form-group id="input-group-image" class="operational-form-grid__wide">
            <label for="input-image"
              >Foto Profil: <em class="text-muted">opsional</em></label
            >
            <clinical-file-upload
              v-model="form.photo"
              accept="image/jpeg,image/png,image/webp"
              browse-text="Pilih file"
              placeholder="Belum ada foto dipilih"
              drop-placeholder="Lepaskan foto di sini"
              @change="onFileUpload"
            ></clinical-file-upload>
            <small class="text-danger">{{ error.photo }}</small>
          </b-form-group>
            </div>
          </div>

          <div class="d-flex justify-content-end mb-5">
          <b-button variant="primary" type="submit">Simpan</b-button>
          <b-button class="ml-2" variant="light" @click="$router.push('/human-resource/employee/list')">Batal</b-button>
          <b-button class="ml-2" variant="light-danger" type="reset">Reset</b-button>
          </div>
        </b-form>
      </div>
    </div>
  </v-app>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import { WebCam } from "vue-web-cam";
import RegionAddressFields from '@/component/general/RegionAddressFields.vue'

export default {
  name: "Form",

  props: {
    form: Object,
    route: String,
    password: Boolean,
  },

  components: {
    "vue-web-cam": WebCam,
    RegionAddressFields,
  },

  data() {
    return {
      imgLoaded: false,
      error: {
        email: "",
        name: "",
        birt_place: "",
        birt_date: "",
        address: "",
        phone: "",
        mobile_phone: "",
        id_card_number: "",
        employee_number_id: "",
        password: "",
        password_confirmation: "",
        position_id: "",
        department_id: "",
        work_start_time: "",
        work_end_time: "",
        photo: "",
        form: "",
      },
      positions: [],
      departments: [],
      employmentOptions: [{value:'permanent',text:'Karyawan Tetap'},{value:'contract',text:'Karyawan Kontrak'},{value:'probation',text:'Masa Percobaan'},{value:'freelance',text:'Mitra / Freelance'}],
      ptkpOptions: ['TK/0','TK/1','TK/2','TK/3','K/0','K/1','K/2','K/3'].map(value=>({value,text:value})),
      imgLoaded: false,
      uploadedImageUrl: "",
      uploadMethod: "upload",
      // camera
      baseImg: null,
      camera: null,
      deviceId: null,
      devices: [],
      img: null,
      captureStatus: false,
      // other
      datePickerPopUp: false,
      passwordIsVisible: "password",
      confirmPasswordIsVisible: "password",

      // date
      time: null,
      menu2: false,
      modal2: false,
      picker: window.medhopToday(),
    };
  },

  methods: {
    resetImg() {
      if (this.uploadedImageUrl.startsWith("blob:")) {
        URL.revokeObjectURL(this.uploadedImageUrl);
      }
      this.uploadedImageUrl = "";
      this.form.photo = [];
      this.img = null;
      this.baseImg = null;
      this.captureStatus = false;
      if (this.uploadMethod === "camera" && this.$refs.webcam) this.onStart();
    },

    formaterDate(val) {
      if (val.length == 4) {
        this.form.birt_date = this.form.birt_date + "-";
      }
      if (val.length == 7) {
        this.form.birt_date = this.form.birt_date + "-";
      }
    },

    onImageLoad() {
      this.imgLoaded = true;
    },

    onFileUpload(evt) {
      if (!evt.target.files || !evt.target.files[0]) return;
      this.uploadedImageUrl = URL.createObjectURL(evt.target.files[0]);
      this.form.photo = evt.target.files[0];
    },

    oncancel() {
      if (this.purpose == "master") {
        this.onStop();
        $router.push("/patient/list");
      } else if (this.purpose == "modal") {
        this.onStop();
        $bvModal.hide("modal-patient");
      }
    },

    changeUploadBtn() {
      if (this.uploadMethod == "upload") {
        this.uploadMethod = "camera";
        setTimeout(() => {
          this.onStart();
        }, 4000);
      } else {
        this.uploadMethod = "upload";
      }
    },

    async getData() {
      let position = await module.setSelectOption("positions");
      let department = await module.setSelectOption("departemens");
      this.positions = position.data;
      this.positions.unshift({
        text: "Pilih Jabatan",
        value: "",
        disabled: true,
      });
      this.departments = department.data;
      this.departments.unshift({
        text: "Pilih Departemen",
        value: "",
        disabled: true,
      });
    },

    async formOnSubmit() {
      let formData = new FormData();
      if (this.img != null) {
        this.form.photo = this.img;
      }
      for (const [key, value] of Object.entries(this.form)) {
        formData.append(key, value);
      }
      // Make Request
      let response = await module.submit(formData, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/human-resource/employee/list");
      }
    },

    // camera method
    onCapture() {
      this.baseImg = this.$refs.webcam.capture();
      this.img = this.dataURItoBlob(this.baseImg);
      this.captureStatus = true;
      this.onStop();
    },
    onStarted(stream) {},
    onStopped(stream) {},
    onStop() {
      this.$refs.webcam.stop();
    },
    onPause() {
      this.$refs.webcam.pause();
    },
    onResume() {
      this.$refs.webcam.resume();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {},
    onCameras(cameras) {
      this.devices = cameras;
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },

    // convert base64 to image
    dataURItoBlob(dataURI) {
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {
        type: mimeString,
      });
    },
  },

  computed: {
    validationMessages() {
      return [...new Set(Object.values(this.error).filter(message => Boolean(message)))];
    },

    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },

  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },

  mounted() {
    this.getData();
  },
};
</script>
